import * as React from 'react';
import { Card, Button } from 'antd';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import ChatItemText from 'kts-platform-frame/display/components/ChatPanel/chatItem/ChatItemText';
import { MyStore, reducers, connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { ChatPanel } from 'kts-platform-frame/display/components';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import UIComponents from './UI.Components';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    cUserId?: string;
    nickName?: string;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({
    cUserId: state.user.userInfo.cUserId,
    nickName: state.user.userInfo.nickName,
}))
export default class Cooperation extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        this.onClickCooperationHandler();
    }

    render() {
        return (
            <ModulesRoot action={ModulesAction}>
                <Card
                    title="协作"
                    className={`card-margin ${css.cooperation}`}
                    extra={<Button onClick={this.onClickCooperationHandler} type="primary">协作</Button>}
                >
                    <ChatPanel
                        title="协作聊天"
                        defaultChatList={this.state.chatList}
                        onSend={this.onSendChatPanelHandler}
                    />
                </Card>
            </ModulesRoot>
        );
    }

    /** 点击了发送功能 */
    private onSendChatPanelHandler = (chatPanel: ChatPanel, text:string) => {
        chatPanel.addChat(
            <ChatItemText
                text={text}
                isSelf={false}
                key={new Date().getTime()}
                timer={new Date().getTime()}
                nickname={this.props.nickName}
            />
        );
        chatPanel.setText('');
    }

    /** 点击了协作 */
    private onClickCooperationHandler = () => {
        const { cUserId } = this.props;
        MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
            title: '协作',
            Components: <ChatPanel title="聊天标题" onSend={this.onSendChatPanelHandler} />
        });
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/InBox/Cooperation/index.tsx